<div class="container">
  <div class="section">
    <h3 class="title">{{ "starter-pages.bank-details.title" | i18next }}*</h3>
    <p class="note">
      {{ "starter-pages.bank-details.description" | i18next }}
    </p>
  </div>
  <div class="bank-container">
    <app-reactive-file-input
      [id]="'bank-book'"
      [type]="'bank-book'"
      [shouldUseNativePicker]="true"
      [labelText]="''"
      sampleImageUrl="../../../../assets/images/bankbook.png"
      [additionalText]="'starter-pages.bank-details.upload-details' | i18next"
      [acceptedFileTypes]="[
        'image/png',
        'image/jpeg',
        'image/jpg',
        'application/pdf'
      ]"
      [capture]="'environment'"
      [formControl]="form.controls.file"
      [errors]="form.controls.file.errors"
      [isTouched]="form.controls.file.touched"
    />
  </div>
  <div class="criteria-container">
    <p class="criteria">
      {{ "starter-pages.bank-details.title-criteria" | i18next }}
    </p>
    <p class="criteria">
      <img src="../../../../assets/icons/check.svg" alt="check" />
      {{ "starter-pages.bank-details.criteria-1" | i18next }}
    </p>
    <p class="criteria">
      <img src="../../../../assets/icons/check.svg" alt="check" />
      {{ "starter-pages.bank-details.criteria-2" | i18next }}
    </p>
    <p class="criteria">
      <img src="../../../../assets/icons/check.svg" alt="check" />
      {{ "starter-pages.bank-details.criteria-3" | i18next }}
    </p>
  </div>
  @if (uploadError) {
  <div>
    <p class="error-message">{{ uploadError }}</p>
  </div>
  }
  
  <div class="section">
    <div class="title">
      {{ "starter-pages.account-details.bank-name-input" | i18next }}
    </div>
    <div class="tw-h-[12px]"></div>
    <app-reactive-ng-select-field
      placeholder="{{
        'starter-pages.account-details.bank-name-input' | i18next
      }}"
      id="bankName"
      [formControl]="getFormControl('bankName')"
      [options]="bankNames"
      [errors]="getFieldError('bankName')"
    />
  </div>

  <div class="section">
    <div class="title">
      {{ "starter-pages.account-details.account-name-input" | i18next }}
    </div>
    <app-reactive-text-input
      placeholder="{{
        'starter-pages.account-details.account-name-input' | i18next
      }}"
      [required]="true"
      [control]="getFormControl('accountName')"
    ></app-reactive-text-input>
    <div class="note-2">
      <i>
        {{ "starter-pages.account-details.accountname-guide" | i18next }}
      </i>
    </div>
  </div>

  <div class="section">
    <div class="title">
      {{ "starter-pages.account-details.account-number-input" | i18next }}
    </div>
    <app-reactive-text-input
      placeholder="{{
        'starter-pages.account-details.account-number-input' | i18next
      }}"
      type="number"
      [control]="getFormControl('accountNumber')"
      reference="bank-number"
      [minNum]="minNum"
      [maxNum]="maxNum"
    ></app-reactive-text-input>
  </div>

</div>

<app-cta-buttons
  currentPage="starter-pages.bank-details"
  [pageNames]="starterPages"
  tier="starter"
  [disabled]="isNextDisabled || isLoading || (form.controls.file.value === undefined || form.controls.file.value== null)"
  [data]="form"
  (nextEvent)="handleNext()"
  [nextCallback]="handleNext"
  [backButton]="false"
></app-cta-buttons>
